(function installZapryBrowserBridge (global) {
  'use strict'

  var METHOD_NAME = 'openExternalBrowser'
  var DEFAULT_TIMEOUT_MS = 1500
  var pending = new Map()
  var sequence = 0
  var previousNativeCallback = null

  function BridgeError (code, message, details) {
    this.name = 'ZapryBrowserBridgeError'
    this.code = code
    this.message = message
    this.details = details || null
    if (Error.captureStackTrace) Error.captureStackTrace(this, BridgeError)
  }
  BridgeError.prototype = Object.create(Error.prototype)
  BridgeError.prototype.constructor = BridgeError

  function bridgeObject () {
    global.ZapryJS = global.ZapryJS || {}
    return global.ZapryJS
  }

  function parseResult (rawResult) {
    if (typeof rawResult !== 'string') return rawResult
    try {
      return JSON.parse(rawResult)
    } catch (e) {
      return rawResult
    }
  }

  function nativeCallback (callbackId, rawResult) {
    var request = pending.get(callbackId)
    if (!request) {
      if (typeof previousNativeCallback === 'function') {
        previousNativeCallback(callbackId, rawResult)
      }
      return
    }

    clearTimeout(request.timer)
    pending.delete(callbackId)
    var result = parseResult(rawResult)
    if (result && result.ok === true) {
      request.resolve(result)
      return
    }

    var code = result && result.code ? result.code : 'INVALID_NATIVE_RESPONSE'
    var message = result && result.message ? result.message : 'Zapry did not return a successful result'
    request.reject(new BridgeError(code, message, result))
  }
  nativeCallback.__zapryBrowserBridgeDispatcher = true

  function installCallback () {
    var bridge = bridgeObject()
    if (bridge.nativeCallback !== nativeCallback) {
      if (
        typeof bridge.nativeCallback === 'function' &&
        !bridge.nativeCallback.__zapryBrowserBridgeDispatcher
      ) {
        previousNativeCallback = bridge.nativeCallback
      }
      bridge.nativeCallback = nativeCallback
    }
  }

  function isAvailable () {
    return typeof bridgeObject().callNative === 'function'
  }

  function openExternalBrowser (url, options) {
    var timeoutMs = options && Number(options.timeoutMs) > 0
      ? Number(options.timeoutMs)
      : DEFAULT_TIMEOUT_MS

    if (typeof url !== 'string' || !url.trim()) {
      return Promise.reject(new BridgeError('INVALID_URL', 'A non-empty URL string is required'))
    }
    if (!isAvailable()) {
      return Promise.reject(new BridgeError(
        'BRIDGE_UNAVAILABLE',
        'ZapryJS.callNative is unavailable. Open this page inside a supported Zapry client.'
      ))
    }

    installCallback()
    var callbackId = 'Async_' + Date.now() + '_' + (++sequence) + '_' + METHOD_NAME
    var payload = JSON.stringify({
      callbackId: callbackId,
      data: { url: url }
    })

    return new Promise(function executeBridge (resolve, reject) {
      var timer = setTimeout(function onTimeout () {
        pending.delete(callbackId)
        reject(new BridgeError(
          'NATIVE_TIMEOUT',
          'No native callback was received. Ask the user to upgrade Zapry or open the link manually.'
        ))
      }, timeoutMs)

      pending.set(callbackId, { resolve: resolve, reject: reject, timer: timer })
      try {
        bridgeObject().callNative(payload)
      } catch (error) {
        clearTimeout(timer)
        pending.delete(callbackId)
        reject(new BridgeError('INVOKE_FAILED', error && error.message ? error.message : String(error)))
      }
    })
  }

  installCallback()
  global.ZapryBrowserBridge = Object.freeze({
    isAvailable: isAvailable,
    openExternalBrowser: openExternalBrowser,
    BridgeError: BridgeError
  })
})(window)
